import { render, staticRenderFns } from "./SchoolCourseList.vue?vue&type=template&id=57234fe8&"
import script from "./SchoolCourseList.vue?vue&type=script&lang=js&"
export * from "./SchoolCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports